import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconUnderline: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconUnderline"><Path d="M7 12V3H5V12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12V3H17V12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12Z" fill="currentColor"/><Path d="M19 22V20H5V22H19Z" fill="currentColor"/></CentralIconBase>;
});

export default IconUnderline;
